import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getAIModelMastersList = async () => {
  return await axiosInstance.get("ai/model-masters/getlist", { headers });
};

export const getAIModelMasterById = async (id) => {
  const response = await axiosInstance.get(`ai/model-masters/get/${id}`, {
    headers,
  });
  return response.data.result;
};

export const addAIModelMaster = async (payload) => {
  return await axiosInstance.post("ai/model-masters/add", payload, { headers });
};

export const updateAIModelMaster = async (payload) => {
  return await axiosInstance.put("ai/model-masters/update", payload, { headers });
};

export const deleteAIModelMaster = async (id) => {
  return await axiosInstance.delete(`ai/model-masters/delete/${id}`, { headers });
};
